module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-br":{"cookiersNotification":{"title":"Uso de cookies","description":" - Guardamos estatísticas de visitas para melhorar sua experiência de navegação. Ao continuar, você concorda com nossa","cookies_policy":"política de cookies.","agreeAndClose":"Concordar e fechar"}}}')
  delete Component.options._Ctor
}
